<template>
 <section>
    <Header :user="user" />
    <main class="main animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
      <div class="contenedor py-0">
         <div class="row px-0 py-0">
            <div class="col-12 px-2 py-0">
              <OliverSales />
            </div>
        </div>
        </div>
    </main>
 </section>
</template>

<script>

import OliverSales from "@/components/Performances/OliverSales.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: 'OliverSalesStats',
  components: {
    OliverSales
  },
  mounted() {
    this.udpdateHeader("oliver_sales_stats");

  },
  data() {
    return {

    };
  },
    computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
    methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },

    }
};
</script>
